export default __webpack_public_path__ + "qca-black.png";